"use client";

import { CommandMenuProvider } from "@/components/command-menu/CommandMenuProvider";
import { RootStoreProvider } from "@/store";
import { AuthStoreProvider } from "@/store/AuthStoreProvider";
import { PostHogProvider } from "@/utils/posthog/PostHogProvider";

import { CableRescue } from "./components/api/CableRescue";

export function Providers({
  serverLoggedIn,
  children,
}: {
  serverLoggedIn: boolean;
  children: React.ReactNode;
}) {
  return (
    <AuthStoreProvider serverLoggedIn={serverLoggedIn}>
      <RootStoreProvider>
        <PostHogProvider>
          <CommandMenuProvider>{children}</CommandMenuProvider>
        </PostHogProvider>
      </RootStoreProvider>
      <CableRescue />
    </AuthStoreProvider>
  );
}
